"use strict";
import { createContext, useContext } from "react";
const StackContext = createContext(null);
const useStackContext = () => useContext(StackContext);
export {
  StackContext,
  useStackContext
};
